import axios from 'axios'
import { serializeParams } from '../utils/genericUtils.js'

export default {
  namespaced: true,

  actions: {
    getNotices(o, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/notice/web/getbybranch',
          method: 'PUT',
          data: payload.filters,
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    //izzy test entidad
    getEntidad() {
      return new Promise((resolve, reject) => {
        axios({
          url: 'https://skolable-3f3e6-default-rtdb.firebaseio.com/entity.json',
          method: 'GET',
        })
          .then((response) => {
            console.log('resolviendo respuesta' + response)
            if (response) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getImage(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/notice/web/image/' + id,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    cancelNotice(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/notice/web/cancelNotice',
          data: obj,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteNotice(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/notice',
          data: obj,
          method: 'DELETE',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getNoticeTools() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/notice/web/tool/gglvlsstds',
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    createNotice(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/notice',
          data: obj,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    createNewNotice(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/notice/web',
          data: obj,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateNotice(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/notice',
          data: obj,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateNoticeNew(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/notice/web/update',
          data: obj,
          method: 'PUT',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getEventReports(_, params) {
      return axios({
        method: 'GET',
        url: `${process.env.VUE_APP_URL}/notice/reports/byType${serializeParams(
          params
        )}`,
      })
    },

    getInfoForReports(o, obj) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/notice/web/reportEvent?id=' + obj,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getNoticeHistory(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/notice/log?id=' + id,
          method: 'GET',
          data: {},
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getNoticeNotConfirmed(o, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/notice/web/unauth?offset=' +
            payload.offset +
            '&size=' +
            payload.size,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getPendingNotices(o, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/notice/web/getpendingnotices?offset=' +
            payload.offset +
            '&size=' +
            payload.size,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getPdf(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/notice/web/file/' + id,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getNotice(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/notice/web/' + id,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    confirmNotice(o, payload) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            process.env.VUE_APP_URL +
            '/notice/web/noticeauth?target=' +
            payload.target,
          method: 'PUT',
          data: payload.notice,
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    authorizeNotice(o, payload) {
      return new Promise((resolve, reject) => {
        axios({
          // url: process.env.VUE_APP_URL + "/notice/web/authorize?target=" + payload.target,
          url:
            process.env.VUE_APP_URL +
            '/notice/web/authorize?target=' +
            payload.target,
          method: 'PUT',
          data: payload.notice,
          params: { confirmDescription: payload.confirmDescription },
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getParentsWatch(o, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/notice/receivedbyparents/' + id,
          method: 'GET',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getSubgrupos() {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/subgroups/web/byBranch',
          method: 'GET',
        })
          .then((response) => {
            if (response.data) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getNoticeDetail(_, id) {
      return axios({
        url: `${process.env.VUE_APP_URL}/notice/details/${id}`,
        method: 'GET',
      })
    },
    getNoticeDetailStudents(_, id) {
      return axios({
        url: `${process.env.VUE_APP_URL}/notice/students/${id}`,
        method: 'GET',
      })
    },
    getNoticeDetailAttendanceParent(_, id) {
      return axios({
        url: `${process.env.VUE_APP_URL}/notice/attendance/${id}/parent`,
        method: 'GET',
      })
    },
    getNoticeDetailAttendanceStudent(_, id) {
      return axios({
        url: `${process.env.VUE_APP_URL}/notice/attendance/${id}/student`,
        method: 'GET',
      })
    },
    getNoticeDetailConfirmedParents(_, id) {
      return axios({
        url: `${process.env.VUE_APP_URL}/notice/confirmedParents/${id}`,
        method: 'GET',
      })
    },
    getNoticeDetailParentsWatched(_, [filter, id]) {
      return axios({
        url: `${
          process.env.VUE_APP_URL
        }/notice/watchedByParents/${id}${serializeParams(filter)}`,
        method: 'GET',
      })
    },
  },
}
